import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg font-bold" }
const _hoisted_2 = { class: "text-base" }
const _hoisted_3 = { class: "flex gap-2 mt-4" }

import { ref } from "vue";
import { LoadingOutlined } from "@ant-design/icons-vue";


import {
  defineComponent,
  defineProps,
  defineEmits,
  onMounted,
  watch,
} from "vue";

const __default__ = defineComponent({
  name: "LbrxPrintModal",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "print"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const selectedButton = ref<string>("");
const isOpen = ref(props.open);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
  }
);

watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

const print = (location: string) => {
  selectedButton.value = location;
  emit("print", location);
  selectedButton.value = "";
};

const backgroundColor = ref("");

onMounted(() => {
  const bgColor = localStorage.getItem("themeTemplate");

  if (bgColor) {
    backgroundColor.value = JSON.parse(bgColor).primaryColor;
  } else {
    backgroundColor.value = "#fc8019";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "600px",
    centered: "",
    open: isOpen.value,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((isOpen).value = $event))
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("Pos.PrintReceipt")), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("Pos.printRceiptPlaceholder")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["flex w-full rounded-md py-2 text-lg items-center justify-center", selectedButton.value === 'productionPoint' ? 'text-white' : '']),
            style: _normalizeStyle(
            selectedButton.value === 'productionPoint'
              ? { backgroundColor: backgroundColor.value }
              : {
                  border: `2px solid ${backgroundColor.value}`,
                  color: backgroundColor.value,
                  backgroundColor: 'transparent',
                }
          ),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (print('productionPoint')))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.productionPoint")), 1)
          ], 6),
          _createElementVNode("button", {
            class: _normalizeClass(["flex w-full rounded-md py-2 text-lg items-center justify-center", selectedButton.value === 'POS' ? 'text-white' : '']),
            style: _normalizeStyle(
            selectedButton.value === 'POS'
              ? { backgroundColor: backgroundColor.value }
              : {
                  border: `2px solid ${backgroundColor.value}`,
                  color: backgroundColor.value,
                  backgroundColor: 'transparent',
                }
          ),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (print('POS')))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.POS")), 1)
          ], 6),
          _createElementVNode("button", {
            class: _normalizeClass(["flex w-full rounded-md py-2 text-lg items-center justify-center", selectedButton.value === 'both' ? 'text-white' : '']),
            style: _normalizeStyle(
            selectedButton.value === 'both'
              ? { backgroundColor: backgroundColor.value }
              : {
                  border: `2px solid ${backgroundColor.value}`,
                  color: backgroundColor.value,
                  backgroundColor: 'transparent',
                }
          ),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (print('both')))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.Both")), 1)
          ], 6)
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})